"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteJob = exports.updateJob = void 0;
var updateJob = function (jobToUpdateIdx, updatedJob, jobs) { return __spreadArray(__spreadArray(__spreadArray([], jobs.slice(0, jobToUpdateIdx), true), [
    updatedJob
], false), jobs.slice(jobToUpdateIdx + 1), true); };
exports.updateJob = updateJob;
var deleteJob = function (jobToDeleteIdx, jobs) {
    return jobs[jobToDeleteIdx].new_revision.id
        ? deleteRevision(jobToDeleteIdx, jobs)
        : deleteNewJob(jobToDeleteIdx, jobs);
};
exports.deleteJob = deleteJob;
/**
 * Deleting a revision that has already been given an ID by the backend
 */
var deleteRevision = function (jobToDeleteIdx, jobs) {
    var deletedJob = __assign(__assign({}, jobs[jobToDeleteIdx]), { new_revision: __assign(__assign({}, jobs[jobToDeleteIdx].new_revision), { deleted_at: Date.now() }) });
    return __spreadArray(__spreadArray(__spreadArray([], jobs.slice(0, jobToDeleteIdx), true), [
        deletedJob
    ], false), jobs.slice(jobToDeleteIdx + 1), true);
};
/**
 * Deleting a revision that has no ID yet
 */
var deleteNewJob = function (jobToDeleteIdx, jobs) {
    return jobs.length === 1
        ? []
        : __spreadArray(__spreadArray([], jobs.slice(0, jobToDeleteIdx), true), jobs.slice(jobToDeleteIdx + 1), true);
};
